import type { Customer } from '@baia-api/baia-api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { notificationsAtom } from '@/state/notifications.ts';
import { customerApi } from '../api/customer';

/**
 * Hook zum Abrufen der Daten des aktuellen Kunden.
 * Die Daten werden von React Query gecached und bereitgestellt.
 */
export const useCustomer = () => {
  return useQuery({
    queryKey: ['customer'],
    queryFn: () => customerApi.getCurrentCustomer(),
  });
};

/**
 * Hook zum Aktualisieren/Speichern des Kundenprofils.
 */
export const useUpdateCustomer = () => {
  const queryClient = useQueryClient();
  const [,setNotifications] = useAtom(notificationsAtom)

  return useMutation({
    mutationFn: (variables: { id: string; data: Partial<Customer> }) =>
      customerApi.update(variables.id, variables.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customer'] });
      setNotifications({type: 'success', message: 'Änderungen erfolgreich gespeichert', title: ''});
    },
  });
};
